/**
 * TicketCreatorContext — single place to open the Type Chooser → New Ticket
 * dialog from anywhere in the app, optionally pre-filling a customer.
 *
 * Phase 5.8k. Replaces the legacy prop-drilling pattern.
 */
import { createContext, useContext, useCallback } from "react";

const TicketCreatorContext = createContext(null);

export function useTicketCreator() {
  const ctx = useContext(TicketCreatorContext);
  if (!ctx) throw new Error("useTicketCreator must be used inside <TicketCreatorProvider>");
  return ctx;
}

/**
 * `onOpen(opts)` is called with `{customerId}` whenever something in the tree
 * calls `openCreator({ customerId })`. AppShell wires this to its own state.
 */
export function TicketCreatorProvider({ children, onOpen }) {
  const openCreator = useCallback((opts = {}) => {
    onOpen?.({ customerId: opts.customerId || null });
  }, [onOpen]);

  return (
    <TicketCreatorContext.Provider value={{ openCreator }}>
      {children}
    </TicketCreatorContext.Provider>
  );
}
